export default __webpack_public_path__ + "static/logo_header-f513cfeb4dba385860b8a19cb5318812.png";